export const title = 'Perfil';
export const logOutButton = 'Cerrar sesión';
